import React from "react";
import "../assets/styles/components/Client.css";
// Importez les images directement
import client1 from "../assets/images/client1-logo.jpg";
import client2 from "../assets/images/client2-logo.jpg";
import client3 from "../assets/images/client3-logo.jpg";
import client4 from "../assets/images/client4-logo.jpg";

const Client = () => {
  const clients = [
    { logo: client1, alt: "Company Logo 1" },
    { logo: client2, alt: "Company Logo 2" },
    { logo: client3, alt: "Company Logo 3" },
    { logo: client4, alt: "Company Logo 4" },
  ];

  return (
    <section id="clients" className="client-section py-5">
      <div className="container text-center">
        <h2 className="section-title">EXEMPLES DE CLIENTS QUI FRÉQUENTENT NOS LOCAUX DE QUALITÉ</h2>
        <div className="row justify-content-center">
          {clients.map((client, index) => (
            <div key={index} className="col-6 col-md-2">
              <img
                src={client.logo}
                alt={client.alt}
                className="client-logo img-fluid"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Client;
